<template>
  <div id="kiosk" style="position:relative; z-index:12; background-color:#00838f; height:100vh; overflow:scroll;">
    <md-toolbar style="width:100%; z-index:15;">
      <div style="display:flex; margin-left:30px;">
        <div class="kioskTitle">Routen</div>
        <div class="kioskHeader">Finden &<br>Bewerten</div>
      </div>
      <h3 @click="reloadKiosk()" class="md-body-1" style="cursor:pointer; flex: 1; text-align:right; padding-top:20px; padding-right:10px;">{{ kioskTitle}}
        <br>in partnership with</h3>
      <img class="logoK" @click="setLocation()" style="margin-left:10px; margin-right:40px; border-left:2px solid #a5c143; cursor:pointer; width:4vw; padding-left:15px;" src="../../assets/kioskLogo.svg" alt="Preview">
    </md-toolbar>

    <md-layout>
      <md-layout md-column md-gutter class="baseKiosk">

        <div style="margin-bottom:15px;">

            <l-map :key="keyKiosk" ref="kioskMap" @click="clickMap()" style="height:720px;" :minZoom="minZoom" :zoom="zoom" :max-bounds="maxBounds" :maxZoom="maxZoom" :options="mapOptions" :crs="crs">
              <Loader id="kioskLoader" style="z-index:988; position:absolute; background-color:rgba(0, 131, 143, 0.7); height:720px; top:unset;" v-show="pageLoading"></Loader>

              <l-image-overlay :bounds="bounds" :url="testmap"></l-image-overlay>

              <l-feature-group ref="features">
                <l-popup v-show="updateKiosk" :options="popupOptions" :id="active.id" >
                  <div :style="popStyle" class="popIndicator"></div>
                  <md-list style="padding:0px !important; border-radius:16px;" class="md-triple-line md-dense">
                    <md-list-item>
                      <md-avatar class="md-avatar-icon md-primary" style="color:white; padding-top:8px;">{{ active.grade }}</md-avatar>
                        <span class="md-subheading">{{ active.routeName }}</span>
                      <span>
                        <md-icon v-if="active.color == 'mixed'"class="mixedColor"></md-icon>
                        <md-icon v-else-if="active.color == 'white'" class="whiteColor"></md-icon>
                        <md-icon v-else :class="active.color" v-bind:style="{ backgroundColor: active.color }"></md-icon>
                      </span>
                      <!-- <div v-if="!rateOpen" class="kioskMore" @click="whatColor(active), changeRateOpen(true)">+</div>
                      <div v-if="rateOpen" class="kioskMore" @click="whatColor(active), changeRateOpen(false)">-</div> -->
                    </md-list-item>
                  </md-list>

                  <KioskRating class="ratingBox" :style="{ top:guestY + 'px' }" v-if="rateOpen"></KioskRating>

                </l-popup>
              </l-feature-group>

              <l-marker :id="marks.id" ref="whatMark"
                v-for="(marks, index) in filteredByAll" :index="index"
                @click="refActive(marks, index), changeRateOpen(true)"
                :lat-lng="whatLatLng(marks)" :key="index"
                :icon="whatIcon(marks)">
              </l-marker>

              <l-control-zoom position="topleft"></l-control-zoom>
              <l-control position="topleft">
                <span class="md-title">{{ filteredByAll.length }} Routen</span>
              </l-control>
            </l-map>
        </div>
        <div style="position:relative; display:flex; margin:auto; max-height:190px; overflow:hidden;">

          <span style="width:649px; margin-right:20px; border-top:5px solid #a5c143; overflow:hidden;">
            <div style="display:block; float:right; top:140px; position:relative; z-index:100;">
              <md-button v-if="videoStatus" class="md-icon-button md-primary" @click="pauseVideo()">
                <md-icon>pause</md-icon>
              </md-button>
              <md-button v-else class="md-icon-button md-primary" @click="playVideo()">
                <md-icon>play_arrow</md-icon>
              </md-button>

            </div>
            <div style="display:block; position:relative; z-index:90; top:-40px;">
              <video :key="videoActive"  width="649" ref="kioskVideo" muted autoplay @ended="nextVideo()">
                <source id="kioskVideo" :src="videoActive" type="video/mp4">
              </video>
            </div>

          </span>

          <span style="max-width:730px; border-top:4px solid #a5c143; overflow:hidden;">
            <img class="kioskPics" :src="sectorPhotos[3].url" width="100%" alt="Route">
          </span>

        </div>
      </md-layout>

      <div style="max-width:380px; position: relative; margin-right:30px; border-top:5px solid #a5c143; background-color:#ffffff;">
        <div class="greenSpinner" style="position:absolute;" v-show="pageLoading">
          <md-spinner md-indeterminate :md-size="90" :md-stroke="1.8" class="md-primary" md-theme="teal" ></md-spinner>
        </div>

        <md-toolbar class="md-transparent kioskBar">
          <span class="kioskSubtitle">RoutenFilter</span>
        </md-toolbar>
        <KioskFilter @clearingPop="clearPop(active)" style="overflow:hidden;"></KioskFilter>


        <div v-show="!markOpen" class="kioskDiv">

          <md-toolbar class="md-transparent kioskBar">
            <span class="kioskSubtitle">RoutenListe</span>

            <md-menu :md-align-trigger="true" :md-offset-x="154" md-offset-y="12" md-direction="bottom left" md-size="6">
              <md-button class="md-icon-button md-primary" md-menu-trigger>
                <md-icon>sort</md-icon>
              </md-button>

              <md-menu-content>
                <md-menu-item v-for="(sortKiosk, index) in sortOptions"
                  :key="index"
                  :value="sortKiosk.query"
                  @click.native="sortkiosklistBy(sortKiosk.query)">

                  <md-icon v-if="sortKiosk.iconset" :md-src="sortKiosk.icon"></md-icon>
                  <md-icon v-else>{{ sortKiosk.icon }}</md-icon>
                  <span>{{ sortKiosk.name }}</span>
                </md-menu-item>
              </md-menu-content>
            </md-menu>
          </md-toolbar>


          <md-list id="kioskList" class="md-dense custom-list md-triple-line" style="position:relative; height: 435px; overflow-y: scroll; max-width: 380px;">

            <md-list-item v-for="(listroute, index) in filteredByAll" ref="bwe" :index="index"
              :key="index" @click="refActive(listroute, index), changeRateOpen(true)" style="position:relative; z-index:10;">

              <md-avatar v-if="climbedRoute.includes(listroute.id)" class="md-avatar-icon md-primary" style="color:white">{{ listroute.grade }}</md-avatar>
              <md-avatar v-else class="md-avatar-icon" style="font-weight: 500; background-color:rgb(217, 236, 238);">{{ listroute.grade }}</md-avatar>

              <div class="md-list-text-container" style="width:120px;">
                <span class="md-title">{{ listroute.routeName }}</span>
                <div v-if="isRecent(listroute.dateCreated)" class="neuTag" style="">NEU</div>

                <span style="display:inherit;">
                  <md-rating-bar v-model="listroute.rating.value" class="md-accent" md-theme="orange" disabled></md-rating-bar>
                  <span style="padding-top:8px;">
                    <span class="md-caption">({{ listroute.rating.count }})</span>
                    <span class="md-caption" v-show="(listroute.isLead)">V</span>
                    <span class="md-caption" v-show="(listroute.isToprope)">T</span>
                    <span class="md-caption" v-show="listroute.remarks"> | {{ listroute.remarks }}</span>
                  </span>
                </span>
              </div>

              <span>
                <md-icon v-if="listroute.color == 'mixed'" class="mixedColor"></md-icon>
                <md-icon v-else-if="listroute.color == 'white'" class="whiteColor"></md-icon>
                <md-icon v-else :class="listroute.color" v-bind:style="{ backgroundColor: listroute.color }"></md-icon>
              </span>

              <md-divider class="md-inset"></md-divider>

            </md-list-item>
            <md-list-item style="min-height:330px">
                  <div class="md-list-text-container">
                  </div>
            </md-list-item>
          </md-list>
        </div>

        <div v-if="markOpen" class="kioskDiv">

          <md-toolbar class="md-transparent kioskBar">
            <span class="kioskSubtitle">RoutenDetails</span>
            <md-button class="md-icon-button md-primary" @click.native="changeRateOpen(false), clearPop()">
              <md-icon>close</md-icon>
            </md-button>
          </md-toolbar>

          <md-list style="display:block; position:relative; height:435px; overflow-y: scroll; max-width: 380px; padding:0px;" class="md-triple-line">

            <md-list-item class="md-triple-line" style="margin-bottom:6px;">
              <md-avatar class="md-avatar-icon md-primary" style="padding-top: 8px; color:white">{{ active.grade }}</md-avatar>
              <div class="md-list-text-container">
                <span class="md-title">{{ active.routeName }}</span>
                <span style="display:inherit;">
                  <md-rating-bar v-model="active.rating.value" class="md-accent" md-theme="orange" disabled></md-rating-bar>
                  <span class="md-caption" style="padding-top:8px;">({{ active.rating.count }})</span>
                </span>
              </div>

              <span>
                <span style="width:100px; right: -10px; position:relative;">
                  <img :src="qrKiosk" alt="QRcode" height="100" width="100">
                </span>
              </span>

              <md-divider class="md-inset"></md-divider>
            </md-list-item>

            <md-list-item class="md-inset">

              <div class="md-list-container">
                <span class="md-caption">Bewertung Kletterer</span>
                <div v-if="active.rating.count" class="subheading kioskDet">{{ active.userGrade }}</div>
                <div v-else class="subheading kioskDet">Route wurde noch nicht bewertet</div>

                <span class="md-caption">Vorstieg/Toprope</span>
                <div class="subheading kioskDet" v-if="(active.isLead==false && active.isToprope==true)">Toprope</div>
                <div class="subheading kioskDet" v-else-if="(active.isLead==true && active.isToprope==true)">Vorstieg | Toprope</div>
                <div class="subheading kioskDet" v-else>Vorstieg</div>

                <span class="md-caption">eingerichtet am</span>
                <div class="subheading kioskDet">{{ active.dateCreated | localdate }}</div>
                <span class="md-caption">geschraubt von</span>
                <div class="subheading kioskDet">{{ active.routeSetter }}</div>

                <span class="md-caption">Hinweise zur Route</span>
                <div class="subheading kioskDet">{{ active.remarks }}</div>
                <span class="md-caption">Charakter der Route</span>
                <div class="subheading kioskDet">{{ attributes | attributesFilter }}</div>
              </div>
            </md-list-item>

            <div v-show="!pageLoading" class="md-inset" style="background-color: #E7F4F5 !important; min-height:54px; padding-left:72px; padding-top:10px;">
              <span class="md-title">Bewertungen
                <span class="md-subheading">({{ active.rating.count }})</span>
              </span>
            </div>

            <md-list-item v-show="!pageLoading" v-for="(routeState, index) in routeStatements" v-bind:key="index">
              <md-avatar v-if="routeState.userName" class="md-avatar-icon md-primary" style="color:white; font-size:20px; padding-top:8px;">
                {{ routeState.userName.charAt(0) }}
              </md-avatar>
              <md-avatar v-else class="md-avatar-icon md-primary" style="color:white; font-size:20px; padding-top:8px;">
                {{ guest.charAt(0) }}
              </md-avatar>
              <div style="overflow:hidden; padding-top:15px; padding-bottom:15px;">
                <div v-if="routeState.userName">{{ routeState.userName }} - <span class="md-body-1">{{ routeState.date | localdate }}</span></div>
                <div v-else>{{ guest }} - <span class="md-body-1">{{ routeState.date | localdate }}</span></div>
                <md-rating-bar v-model="routeState.rating" class="md-accent" md-theme="orange" disabled></md-rating-bar>

                <div class="md-caption" style="word-break: normal; white-space:normal;">{{ routeState.grade }} {{ routeState.attributes | skillsFilter | attributesFilter }}</div>
                <span class="md-caption" style="word-break: normal; white-space:normal;">{{ routeState.comment }}</span>
              </div>
              <md-divider></md-divider>

            </md-list-item>

          </md-list>
        </div>

      </div>
    </md-layout>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import { mapGetters } from 'vuex'

import { LMap, LImageOverlay, LMarker, LPopup, LIcon, LControl, LControlZoom, LFeatureGroup } from 'vue2-leaflet'
import KioskFilter from '../Kiosk/KioskFilter'
import KioskRating from '../Kiosk/KioskRating'
import Carousel from '../Sectors/Carousel.vue'
import Loader from '../Loader'

export default {
  name: 'kiosk',

  components: {
    KioskFilter,
    KioskRating,
    LMap,
    LImageOverlay,
    LMarker,
    LIcon,
    LControl,
    LControlZoom,
    LPopup,
    LFeatureGroup,
    Carousel,
    Loader
  },

  data: () => ({
    isFilterOn: false,
    qrKiosk: 'backendclimbo-backend/v1/sector/7626/route/7892/qr',
    movie: 'godfather',
    scrollActive: true,
    kioskTitle: 'Magic Mountain',
    kioskSector: '',
    mapOptions: { zoomControl: false, attributionControl: false },
    center: L.latLng(220,350),
    draggable: false,
    bounds: [[0, 0], [220, 350]],
    maxBounds: [[20, 0], [200, 350]],
    minZoom: 1.5,
    maxZoom: 6,
    zoom:1.5,
    crs: L.CRS.Simple,
    guestY: '',

    videoStatus: true,
    videoActive: 'static/kiosk_onevideo.mp4',
    keyVideo: 1,

    iconGreen: L.icon({
      iconUrl: 'static/kioskMarkGreen.svg',
      iconSize: [14, 14],
      iconAnchor: [7, 7],
      popupAnchor: [60, -4],
    }),
    iconPink: L.icon({
      iconUrl: 'static/kioskMarkPink.svg',
      iconSize: [18, 18],
      iconAnchor: [9, 9],
      popupAnchor: [60, -4],
    }),

    popStyle: {
      marginTop:'0px',
      left:'-7px',
      backgroundColor: '#ffffff'
    },

    popupOptions: {
      autoClose: true,
      closeOnClick: true,
      autoPan: false,
      keepInView: true,
      autoPanPaddingBottomRight: [20,22],
      minWidth: 320,
      maxWidth: 360,
      offset: (0, 137),
    },

    testmap: '../../../static/kioskMM.svg',

    isLead: false,
    isToprope: false,

    totalRoutes: '',
    climbedRoute: [],

    keyKiosk: 1,
    isRouteActive: 0,
    today: new Date().getTime(),

    minGrade: 2,
    maxGrade: 36,

    vorstieg: false,
    tropope: false,
    isContest: false,
    isNeuFilter: false,
    contestOp: 'Wettbewerb',

    lowest: 1,
    highest: 36,

    sortSelected: 'view_list',
    guest: 'Gast',
  }),


  created() {
    this.kioskEntryLink()
  },

  mounted() {
    this.$refs.kioskMap.mapObject.setView([110, 350], 1.5)
  },

  computed: {
    ...mapState([
      'sectorDetails',
      'active',
      'storeList',
      'marker',
      'attributes',
      'sortOptions',
      'routeStatements',
      'sectorPhotos',
      'promoPhotos',
      'pageLoading',
      'updateKiosk',
      'tenduLoading',
      'markOpen',
      'rateOpen',
      'popCount',
      'popValue'
    ]),

    ...mapGetters([  // you won't need to destructure if
     'filteredByKeyword',   // you have no plans of adding other computed
     'filteredByVorstieg',  // properties. It would be safer anyway to keep it.
     'filteredByAll',
     'filteredByRating',
     'filteredByToprope',
     'filteredByGrade'
    ]),

    sectorId () {
      return this.$store.state.sectorDetails.id
    },



  },

  methods: {
    ...mapMutations([
      'changeActive',
      'changeMarker',
      'changeStoreList',
      'changeUpdateKiosk',
      'changeResetKiosk',
      'changePageLoading',
      'changeMarkOpen',
      'changeRateOpen',
      'changeSlideRange'
    ]),

    playVideo() {
      this.$refs.kioskVideo.play()
      this.videoStatus = true
    },

    pauseVideo() {
      this.$refs.kioskVideo.pause()
      this.videoStatus = false
    },

    nextVideo() {
      this.videoStatus = false
      this.$refs.kioskVideo.pause()
      // this.videoActive = 'static/kiosk_onevideo.mp4'
      setTimeout(() => {
        this.videoStatus = true
        // this.videoActive = 'static/kiosk_onevideo.mp4'
        this.$refs.kioskVideo.play()
      }, 15000)
    },

    clickMap(){
      this.changeMarkOpen(false)
    },

    reloadKiosk(){
      window.location.reload(true);
    },

    whatLatLng(marks) {
      var nx = marks.overview.x
      var ny = marks.overview.y
      return L.latLng(nx, ny)
    },

    clearPop(item) {
      this.$refs.kioskMap.mapObject.closePopup();
      this.changeMarkOpen(false)
      this.changePageLoading(false)
    },

    whatPosition(item) {
      if (item.lat > 110 && item.lng > 200) {
        this.guestY = 70
        return this.popupOptions.offset = [-190, 54]
      } else if (item.lat < 110 && item.lng < 200) {
        this.guestY = -344
        return this.popupOptions.offset = [190, 54]
      } else if (item.lat > 110 && item.lng <= 200) {
        this.guestY = 70
        return this.popupOptions.offset = [190, 54]
      } else if (item.lat < 110 && item.lng >= 200) {
        this.guestY = -344
        return this.popupOptions.offset = [-190, 54]
      }
    },

    whatColor(item) {
      var popItem = this.whatLatLng(item)
      this.whatStyle(popItem)
    },

    whatStyle(popItem) {
      if (popItem.lat > 110 && popItem.lng > 200) {
        this.popStyle.marginTop = '32px'
        this.popStyle.left = '330px'
      } else if (popItem.lat < 110 && popItem.lng < 200) {
        this.popStyle.marginTop = '32px'
        this.popStyle.left = '-8px'
      } else if (popItem.lat > 110 && popItem.lng <= 200) {
        this.popStyle.marginTop = '32px'
        this.popStyle.left = '-8px'
      } else if (popItem.lat < 110 && popItem.lng >= 200) {
        this.popStyle.marginTop = '32px'
        this.popStyle.left = '330px'
      }
      // document.getElementById('kioskList').scrollTop = (index*88)

    },

    whatIcon(item) {
      if (this.active.id == item.id) {
        return L.icon({
          iconUrl: 'static/kioskMarkPink.svg',
          iconSize: [24, 24],
          iconAnchor: [12, 12],
        })
      } else {
        return L.icon({
          iconUrl: 'static/kioskMarkGreen.svg',
          iconSize: [14, 14],
          iconAnchor: [7, 7],
        })
      }
    },

    refActive (item, index) {

      this.changeActive(item)

      var slide = (this.active.gradeNo * 3).toFixed(0)
      this.changeSlideRange(slide)

      var popItem = this.whatLatLng(item)
      this.whatPosition(popItem)
      this.whatStyle(popItem)
      this.$store.dispatch('getRouteStatements', this.active.links.route)

      this.qrKiosk = process.env.BACKEND_URL + item.links.route + '/qr'
      this.$nextTick(() => {
        this.$refs.features.mapObject.openPopup(popItem)
      })
      // console.log('routeStatements', this.routeStatements)
      this.changeMarkOpen(true)

    },

    isRecent (item) {
      var neuCal = ( this.today - item ) / 86400000
      if (neuCal < 30) {
        return true
      } else {
        return false
      }
    },

    sortkiosklistBy (sorts) {
      this.$store.dispatch('refreshList', this.sectorDetails.links.routes + sorts)
      .then(response => {
        this.changeResetKiosk(false)
        document.getElementById('kioskList').scrollTop = 0
      })
    },

    setLocation() {
      this.sortkiosklistBy('')
      this.changeMarkOpen(false)
      this.$refs.kioskMap.mapObject.setView([110, 350], 1.5)
    },

    kioskEntryLink () {
      var kioskEntry = 'climbo-backend/v1/kiosk/entrypoint'
      this.$http.get(kioskEntry)
      .then(function (response) {
        var sectorLink = response.data.links.sector
        var routesLink = response.data.links.routes
        this.$store.dispatch('getSector', sectorLink)
          .then(response => {
            // console.log('success')
            this.$store.dispatch('refreshList', routesLink)
          })
        }, response => {
          console.log('not success')
        })
    }
  },
}

</script>

<style scope>

  #kioskLoader .loadLogo img{
    filter: contrast(00%) brightness(200%);
  }

  #kioskLoader .loadLogo {
    color:#ffffff;
  }

  #kioskLoader .loadLogo .loader > div {
    background-color:#ffffff !important;
  }

  .baseKiosk {
    top:130px;
    border-top:5px solid #a5c143;
    margin-left:30px;
    margin-right:30px;
    overflow: hidden;
    padding:15px 25px;
    background-color:#ffffff;
  }

  .kioskImage {
    min-width:100%;
    touch-action:none;
  }

  #kioskleaf img {
    max-width: unset !important;
  }

  #kiosk #routebar {
    display:none !important;
  }

  #kiosk .routepreview {
    display:none !important;
  }

  #kiosk #TopHeader {
    display:none !important;
  }

  #kiosk #filterbar {
    display:none !important;
  }

  .logoK:hover {
    opacity:0.4;
  }

  .kioskMore {
    background-color:#c51162;
    min-height: 76px;
    display: block;
    position: relative;
    color: #ffffff;
    text-align: center;
    width: 50px;
    right: -24px;
    font-size:32px;
    vertical-align: middle;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
    padding-top: 12px;
    cursor:pointer;
  }

  a.leaflet-popup-close-button{
    display:none;
  }
  .leaflet-popup-content-wrapper {
    padding:0px !important;
  }

  .kioskDet {
    padding-top:0px; padding-bottom:8px;
  }

  .leaflet-popup-tip-container {
    display:none;
    margin-left:-150px !important;
  }

  .kioskQR {
    float:left;
    padding:10px;
  }

  .md-boards-navigation {
    display:none !important;
  }

  .kioskBar {
    width:380px;
    min-height:54px;
    border-bottom:1px solid #a5c143;
  }

  .kioskDiv {
    border-top:5px solid #a5c143;
    /* max-height:460px; */
    overflow:hidden;
  }

  .kioskPromos {
    position:relative;
    top:0px;
    width:100%;
    overflow:hidden;
  }

  .kioskPics {
    position:relative;
    top:-60px;
    width:100%;
    overflow:hidden;
  }

  .ratingBox {
    box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.4);
    -webkit-box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.4);
    position:absolute;
    border-radius: 8px;
    left:0px;
    background-color:#fff;
    z-index:777;
  }

</style>
